export const CalendarEventState = {
  VISIBLE: "visible",
  UNKNOWN: "unknown",
  INVISIBLE: "invisible",
} as const;

export type CalendarEventStateValue =
  (typeof CalendarEventState)[keyof typeof CalendarEventState];

export interface CalendarEvent {
  id: number;
  uuid: string;
  content: string | null;
  title?: string | null;

  high: string | null;
  low: string | null;
  expected: string | null;
  actual: string | null;
  previous: string | null;
  revised: string | null;
  net: string | null;
  survey_date?: string | null;
  occurs_at: string;

  category?: {
    importance?: string;
    location?: string;
    name?: string;
    state?: CalendarEventStateValue;
    unit?: string; // e.g., "%", "B", "M"
    currency?: string; // e.g., "CHF", "€"
  };

  [key: string]: unknown;
}

export const isCalendarEventVisible = (event: CalendarEvent): boolean =>
  event.category?.state === CalendarEventState.VISIBLE;
